import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";


const Community = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <div className="community container">
      <div className="community__title">
        <h3 style={{fontSize:14}}>{translations[selectedLanguages].community.title}</h3>
        <p>{translations[selectedLanguages].community.description}</p>
      </div>
      <Link to="/contact">
        {translations[selectedLanguages].community.button}
      </Link>
    </div>
  );
};

export default Community;
